// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1lA5W","author":"Table_author__2C034","authorImage":"Table_authorImage__lHuGZ","unreadRow":"Table_unreadRow__1n8dp"};